<script setup>
import { ref, watch, reactive } from "vue";
import NotesStateMap from "Modules/NoteStatesMap";
import { useStore } from "vuex";
let store = useStore();
let isVerified = store.getters.getUserPerms.verified;

let props = defineProps({
  note: Object,
  updatedStatus: String,
});
let noteState = undefined;
if (props.note.needs_attention)
  noteState = props.note?.number_of_responses > 0 ? ref('Resp:Needs Attention') : ref('Needs Attention');
else
  noteState = ref(NotesStateMap[props.note.state]);
let responseCount = ref(props.note?.number_of_responses);
let updatedStatus = ref(NotesStateMap[props.updatedStatus]);
let archived = ref(props.note.archived);

watch(props, (newVal, oldVal) => {
  if (oldVal) {
    if (props.note.needs_attention)
      noteState.value = props.note?.number_of_responses > 0 ? 'Resp:Needs Attention' : 'Needs Attention';
    else
      noteState.value = NotesStateMap[props.note.state];

    responseCount.value = props.note?.number_of_responses;
    if (props.updatedStatus) {
      updatedStatus.value = NotesStateMap[props.updatedStatus];
    }
  }
});
</script>
<template>
  <div class="flex justify-start mt-1 lg:mb-0 font-roboto">
    <!-- <TransitionGroup name="fade-pull"> -->
    <template v-if="updatedStatus">
      <div v-if="updatedStatus === 'Draft'" class="base-label  bg-pastel-purple-lighter text-rare-darker">
        <span class="text-neutral-alt"> new! </span> Draft
      </div>
      <div v-else-if="updatedStatus === 'Processing'" class="base-label  bg-pastel-purple-lighter text-rare-darker">
        <span class="text-neutral-alt"> new! </span> Processing
      </div>
      <div v-else-if="updatedStatus === 'Awaiting Review'" class="base-label  bg-pastel-yellow-light text-secondary-darker">
        <span class="text-neutral-alt"> new! </span> Awaiting Review
      </div>
      <div v-else-if="updatedStatus === 'In Review'" class="base-label  bg-pastel-blue-lighter text-main">
        <span class="text-neutral-alt"> new! </span> In Review
      </div>
      <div v-else-if="updatedStatus === 'Verified'" class="base-label  bg-pastel-green-lighter text-rare2 ">
        <span class="text-neutral-alt"> new! </span> Verified
      </div>
      <div v-else-if="updatedStatus === 'In PMS'" class="base-label  bg-pastel-green-lighter text-rare2">
        <span class="text-neutral-alt"> new! </span>  In PMS
      </div>
    </template>
    <div v-else-if="archived" class="base-label bg-gray-200 text-gray-700">
      <span class="mx-1 my-auto w-6">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#404040" viewBox="0 0 24 24" height="20" width="20"><path d="M3,3H21V7H3V3M4,8H20V21H4V8M9.5,11A0.5,0.5 0 0,0 9,11.5V13H15V11.5A0.5,0.5 0 0,0 14.5,11H9.5Z" /></svg>
      </span> Archived
    </div>
    <div v-else-if="noteState === 'Draft'" class="base-label  bg-pastel-purple-lighter text-rare-darker">
      <span class="mx-1 my-auto w-6">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#5273E2" viewBox="0 0 24 24" height="20" width="20"><path d="M12,2A3,3 0 0,1 15,5V11A3,3 0 0,1 12,14A3,3 0 0,1 9,11V5A3,3 0 0,1 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7A5,5 0 0,0 12,16A5,5 0 0,0 17,11H19Z" /></svg>
      </span>
      Draft
    </div>
    <div v-else-if="noteState === 'Processing'" class="base-label  bg-pastel-purple-lighter text-rare-darker">
      <span class="mx-1 my-auto w-6">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#5273E2" viewBox="0 0 24 24" height="20" width="20"><title>refresh</title><path d="M17.65,6.35C16.2,4.9 14.21,4 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20C15.73,20 18.84,17.45 19.73,14H17.65C16.83,16.33 14.61,18 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6C13.66,6 15.14,6.69 16.22,7.78L13,11H20V4L17.65,6.35Z" /></svg>
      </span>
      Processing
    </div>
    <div v-else-if="noteState === 'Awaiting Review'" class="base-label  bg-pastel-yellow-light text-secondary-darker">
      <span class="mx-1 my-auto w-6">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#C48D2B" viewBox="0 0 24 24" height="20" width="20"><path d="M21 11.11V5C21 3.9 20.11 3 19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H11.11C12.37 22.24 14.09 23 16 23C19.87 23 23 19.87 23 16C23 14.09 22.24 12.37 21 11.11M12 3C12.55 3 13 3.45 13 4S12.55 5 12 5 11 4.55 11 4 11.45 3 12 3M6 7H18V9H6V7M9.08 17H6V15H9.08C9.03 15.33 9 15.66 9 16S9.03 16.67 9.08 17M6 13V11H11.11C10.5 11.57 10.04 12.25 9.68 13H6M16 21C13.24 21 11 18.76 11 16S13.24 11 16 11 21 13.24 21 16 18.76 21 16 21M16.5 16.25L19.36 17.94L18.61 19.16L15 17V12H16.5V16.25Z" /></svg>
      </span>
      Awaiting Review
    </div>
    <div v-else-if="noteState === 'In Review'" class="base-label  bg-pastel-blue-lighter text-main">
      <span class="mx-1 my-auto w-6">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#0386B7" viewBox="0 0 24 24" height="20" width="20"><path d="M15.84 10.2L14.83 11.21L12.76 9.18L13.77 8.16C13.97 7.95 14.31 7.94 14.55 8.16L15.84 9.41C16.05 9.62 16.06 9.96 15.84 10.2M8 13.91L12.17 9.72L14.24 11.8L10.08 16H8V13.91M13 2V4C17.39 4.54 20.5 8.53 19.96 12.92C19.5 16.56 16.64 19.43 13 19.88V21.88C18.5 21.28 22.45 16.34 21.85 10.85C21.33 6.19 17.66 2.5 13 2M11 2C9.04 2.18 7.19 2.95 5.67 4.2L7.1 5.74C8.22 4.84 9.57 4.26 11 4.06V2.06M4.26 5.67C3 7.19 2.24 9.04 2.05 11H4.05C4.24 9.58 4.8 8.23 5.69 7.1L4.26 5.67M2.06 13C2.26 14.96 3.03 16.81 4.27 18.33L5.69 16.9C4.81 15.77 4.24 14.42 4.06 13H2.06M7.06 18.37L5.67 19.74C7.18 21 9.04 21.79 11 22V20C9.58 19.82 8.23 19.25 7.1 18.37H7.06Z" /></svg>
      </span>
      In Review
    </div>
    <div v-else-if="noteState === 'Verified'" class="base-label  bg-pastel-green-lighter text-rare2 ">
      <span class="mx-1 my-auto w-6">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#03B78E" viewBox="0 0 24 24" height="20" width="20"><path d="M23 12L20.6 9.2L20.9 5.5L17.3 4.7L15.4 1.5L12 3L8.6 1.5L6.7 4.7L3.1 5.5L3.4 9.2L1 12L3.4 14.8L3.1 18.5L6.7 19.3L8.6 22.5L12 21L15.4 22.5L17.3 19.3L20.9 18.5L20.6 14.8L23 12M18.7 16.9L16 17.5L14.6 19.9L12 18.8L9.4 19.9L8 17.5L5.3 16.9L5.5 14.1L3.7 12L5.5 9.9L5.3 7.1L8 6.5L9.4 4.1L12 5.2L14.6 4.1L16 6.5L18.7 7.1L18.5 9.9L20.3 12L18.5 14.1L18.7 16.9M16.6 7.6L18 9L10 17L6 13L7.4 11.6L10 14.2L16.6 7.6Z" /></svg>
      </span>
      {{ isVerified ? 'Verified' : 'Reviewed' }}
    </div>
    <div v-else-if="noteState === 'In PMS'" class="base-label bg-pastel-green-lighter text-rare2">
      <span class="mx-1 my-auto w-6">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#03B78E" viewBox="0 0 24 24" height="20" width="20"><path d="M23,12L20.56,9.22L20.9,5.54L17.29,4.72L15.4,1.54L12,3L8.6,1.54L6.71,4.72L3.1,5.53L3.44,9.21L1,12L3.44,14.78L3.1,18.47L6.71,19.29L8.6,22.47L12,21L15.4,22.46L17.29,19.28L20.9,18.46L20.56,14.78L23,12M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9L10,17Z" /></svg>
      </span>
      {{ isVerified ? 'Verified and In PMS' : 'Completed (In PMS)' }}
    </div>
    <div v-else-if="noteState === 'Needs Attention'" class="base-label  bg-error-lighter text-error">
      <span class="mx-1 my-auto w-6">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#F54C57" viewBox="0 0 24 24" height="20" width="20"><path d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg>
      </span>
      Needs Attention
    </div>
    <div v-else-if="noteState === 'Resp:Needs Attention'"
         class="base-label pl-1 pr-3 flex justify-center whitespace-nowrap bg-error-lighter">
      <div class="resp-notif w-4 h-4 lg:w-5 lg:h-5 flex mr-1 rounded-full bg-error align-middle border border-white">
        <div class="flex flex-col flex-grow justify-center">
          <div class="my-auto text-white font-roboto-condensed font-bold text-xs md:text-xs text-center leading-[initial]">
            {{ responseCount ?? 1 }}
          </div>
        </div>
      </div>
      <span class="my-auto text-error font-semibold">Needs Attention</span>
    </div>
    <div v-else-if="noteState === 'Archived'" class="base-label bg-gray-200 text-gray-700 ">
      Archived
    </div>

  </div>
</template>


<style scoped>
.base-label {
  @apply text-xs;
  @apply leading-3;
  @apply flex;
  @apply items-center;
  @apply rounded;
  @apply pr-3;
  @apply pl-1;
  @apply py-1;
}
</style>